import React, { useState } from "react";
import "./ChatDrawer.css";
import MahalAI from "../../images/Mahalai1.jpg";




const ChatDrawer = ({ onClose }) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [messages, setMessages] = useState([
    {
      sender: "assistant",
      text: "👋 Hi!\n\nI'm Mahal AI.\n\nHow can I help you today?"
    }
  ]);
  const suggestions = [
  "How do I create a supplier account?",
  "How do I register my restaurant?",
  "How do I add a menu?",
];

 const sendMessage = async (question = null) => {

    const userMessage =
        typeof question === "string"
            ? question
            : message;

    if (!userMessage || !userMessage.trim()) return;

    setMessages((prev) => [
      ...prev,
      {
        sender: "user",
        text: userMessage
      }
    ]);

    setMessage("");

    setLoading(true);

    try {

      const response = await fetch(
        "https://api.mahal.qa/api/chat",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            message: userMessage
          })
        }
      );

      const data = await response.json();

      setMessages((prev) => [
        ...prev,
        {
          sender: "assistant",
          text: data.response
        }
      ]);

    } catch (error) {

      setMessages((prev) => [
        ...prev,
        {
          sender: "assistant",
          text: "⚠ Unable to connect to Mahal AI."
        }
      ]);

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="chat_overlay">

      <div className="chat_drawer">

        {/* Header */}

        <div className="aichat_header">

          <h4 className="aichat_title">
    <img
        src={MahalAI}
        alt="Mahal AI"
        className="mahal_ai_icon"
    />

    <span>Mahal AI</span>
</h4>

          <button onClick={onClose}>
            ✕
          </button>

        </div>

        {/* Chat */}

        <div className="chat_body">

  {messages.map((msg, index) => (

    <div
      key={index}
      className={
        msg.sender === "user"
          ? "user_message"
          : "assistant_message"
      }
    >
      {msg.text}
    </div>

  ))}

  {/* Suggestions */}

  {messages.length === 1 && (

    <div className="suggestions">

      <h5>Try asking</h5>

      {suggestions.map((question, index) => (

        <button
          key={index}
          className="suggestion_btn"
          onClick={() => sendMessage(question)}
        >
          {question}
        </button>

      ))}

    </div>

  )}

  {loading && (

    <div className="assistant_message">
      Mahal AI is thinking...
    </div>

  )}

</div>

        {/* Footer */}

        <div className="chat_footer">

          <input
            type="text"
            placeholder="Ask Mahal AI..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                sendMessage();
              }
            }}
          />

          <button
            onClick={() => sendMessage()}
            disabled={loading}
        >
            {loading ? "..." : "Send"}
          </button>

        </div>

      </div>

    </div>

  );

};

export default ChatDrawer;